import { useEffect, useState } from "react";
import { ArrowUpRight, BadgePercent } from "lucide-react";
import { PageHero } from "../components/pages/Blocks";
import { Reveal, Eyebrow } from "../components/landing/Reveal";
import { DonateForm } from "../components/pages/DonateForm";

const FUNDS = [
  { title: "Sponsor a Child", text: "Sponsor a child with a yearly donation that covers their needs for a full year.", image: "/images/g2.jpg" },
  { title: "Education and Nutrition Support", text: "By sponsoring a child, you enable us to offer education, health services, aids, and necessary assistance to children with disabilities. An amount of Rs.15,000 will support all these requirements for approximately a year for one child.", image: "/images/p9.jpg" },
  { title: "General Funds", text: "Fund for charitable contributions.", image: "/images/p6.jpg" },
];

export default function Donation() {
  const [fund, setFund] = useState(FUNDS[0].title);
  const pick = (f) => {
    setFund(f);
    const el = document.getElementById("donate-form");
    if (!el) return;
    const y = el.getBoundingClientRect().top + window.scrollY - 100;
    if (window.__lenis) window.__lenis.scrollTo(y);
    else window.scrollTo({ top: y, behavior: "smooth" });
  };
  useEffect(() => {
    document.title = "Donate | Wings of Fire Foundation";
  }, []);
  return (
    <div data-testid="page-donation">
      <PageHero eyebrow="Donate" title="Empower a Child's Future" intro="Your generous contribution helps us provide education, life skills, and comprehensive support to children and young adults with disabilities. Together, we can create an inclusive society where every child has the opportunity to thrive and reach their full potential." image="/images/g2.jpg" />
      <section className="bg-[#F3EADF] py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <Eyebrow>Impact of Your Donation</Eyebrow>
          <h2 className="font-serif text-4xl sm:text-5xl text-[#0F1D2F] mt-5">Choose where your gift goes</h2>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
            {FUNDS.map((f, i) => (
              <Reveal key={f.title} delay={i * 0.08} className="h-full">
                <button type="button" onClick={() => pick(f.title)} data-testid={`fund-card-${i}`} className="group h-full w-full text-left flex flex-col rounded-[28px] bg-white overflow-hidden border border-[#0F1D2F]/10 hover:border-[#CF5C0F] transition-colors">
                  <div className="aspect-[4/3] overflow-hidden"><img src={f.image} alt={f.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" /></div>
                  <div className="p-7 flex flex-col flex-1">
                    <h3 className="font-serif text-2xl text-[#0F1D2F]">{f.title}</h3>
                    <p className="mt-3 text-[#3A4756] leading-relaxed flex-1">{f.text}</p>
                    <span className="btn-fire mt-6 self-start">Donate <ArrowUpRight className="w-4 h-4" /></span>
                  </div>
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <section className="bg-[#F3EADF] pb-20 lg:pb-28">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <DonateForm fund={fund} setFund={setFund} />
        </div>
      </section>
      <section className="bg-[#FAF7F2] py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div data-testid="tax-exemption-box" className="rounded-[28px] bg-[#1B3824] text-white p-8 sm:p-10">
              <BadgePercent className="w-10 h-10 text-[#F2B36B]" />
              <h3 className="font-serif text-3xl sm:text-4xl mt-6">80G Tax Exemption</h3>
              <p className="mt-4 text-[#E2E8E4] text-lg leading-relaxed">All donations made by Indian donors are eligible for tax deduction under Section 80G of the Income Tax Act.</p>
            </div>
            <h3 className="font-serif text-3xl text-[#0F1D2F] mt-12">Any other Independent Donations</h3>
            <p className="mt-3 text-[#2B3A4A] text-lg">You can scan and pay the amount with any UPI app.</p>
          </div>
          <Reveal className="lg:col-span-5 flex justify-center">
            <img data-testid="donation-qr" src="/images/qr.png" alt="Wings of Fire Foundation UPI QR code" className="w-full max-w-[300px] rounded-[24px] shadow-[0_30px_60px_-25px_rgba(15,29,47,0.4)]" />
          </Reveal>
        </div>
      </section>
    </div>
  );
}
